var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMingcuteRightLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:right-line",
    clipPath: "url(#clip0_155_228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9178 11.8799C16.1053 12.0674 16.2106 12.3217 16.2106 12.5869C16.2106 12.852 16.1053 13.1063 15.9178 13.2939L10.2608 18.9509C10.1685 19.0464 10.0582 19.1225 9.9362 19.175C9.81419 19.2274 9.68297 19.2549 9.55019 19.2561C9.41741 19.2573 9.28573 19.232 9.16284 19.1817C9.03994 19.1314 8.92829 19.0571 8.8344 18.9632C8.7405 18.8694 8.66625 18.7577 8.61597 18.6348C8.56569 18.5119 8.54039 18.3802 8.54154 18.2475C8.5427 18.1147 8.57028 17.9835 8.62269 17.8614C8.6751 17.7394 8.75128 17.6291 8.84679 17.5369L13.7968 12.5869L8.84679 7.63685C8.66463 7.44825 8.56384 7.19565 8.56612 6.93345C8.5684 6.67125 8.67356 6.42044 8.85897 6.23503C9.04438 6.04962 9.29519 5.94445 9.55739 5.94218C9.81959 5.9399 10.0722 6.04069 10.2608 6.22285L15.9178 11.8799Z",
    fill: "#3A3A3A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.210693 0.586914)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteRightLine);
export default __webpack_public_path__ + "static/media/mingcute_right-line.663b05e647e68b5beb5dfac41e420129.svg";
export { ForwardRef as ReactComponent };